export default {
  updateDetails(data) {
    data.PaymentReturn = data.PaymentValue - data.Total;

    data.TotalItems = 0;
    for (const item of data.Items) {
      data.TotalItems += item.RequestedQuantity;
    }
  },
  updateItems(items) {
    for (const item of items) {
      item.DiscountedValue = (item.DispatchSellPrice - item.SellPrice)
        * item.RequestedQuantity;

      const isNegativeDiscount = item.DiscountedValue < 0;
      if (isNegativeDiscount) {
        item.DispatchSellPrice = item.SellPrice;
      }

      item.BasicTotalPrice = item.DispatchSellPrice
        * item.RequestedQuantity;
    }
  }
}